const bulan = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
]

function FindTodayDate_DDMMYY(date: string) {
  if (date !== '') {
    let sliceDate = date.slice(0, 10)
    let splitDate = sliceDate.split('-')
    return splitDate[2] + ' ' + bulan[Number(splitDate[1]) - 1] + ' ' + splitDate[0]
  } else {
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = bulan[today.getMonth()]
    let yyyy = today.getFullYear()
    return dd + ' ' + mm + ' ' + yyyy
  }
}

export {FindTodayDate_DDMMYY}
